import clsx from "clsx";

export function LabelBase({
    dot = false,
    text,
    color,
    className,
}: {
    dot?: boolean;
    text: string;
    color?: string;
    className?: string;
}) {
    return (
        <div
            className={clsx(
                "flex cursor-pointer items-center gap-2",
                className,
            )}
        >
            {dot && (
                <div
                    style={{ backgroundColor: color }}
                    className={clsx(
                        "size-2 shrink-0 rounded-full",
                        !color && "bg-gray-400",
                    )}
                />
            )}
            <p className="body-s cursor-pointer break-all pr-1">{text}</p>
        </div>
    );
}
